import { render, staticRenderFns } from "./TakeoverDialog.vue?vue&type=template&id=2d0e3430&"
import script from "./TakeoverDialog.vue?vue&type=script&lang=js&"
export * from "./TakeoverDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports